const actions = {
  GET_ORGANIZATIONS_REQUEST: "GET_ORGANIZATIONS_REQUEST",
  GET_ORGANIZATIONS_SUCCESS: "GET_ORGANIZATIONS_SUCCESS",

  ADD_ORGANIZATION_REQUEST: "ADD_ORGANIZATION_REQUEST",
  ADD_ORGANIZATION_SUCCESS: "ADD_ORGANIZATION_SUCCESS",

  DELETE_ORGANIZATION_REQUEST: "DELETE_ORGANIZATION_REQUEST",
  DELETE_ORGANIZATION_SUCCESS: "DELETE_ORGANIZATION_SUCCESS",

  GET_CITIES_REQUEST: "GET_CITIES_REQUEST",
  GET_CITIES_SUCCESS: "GET_CITIES_SUCCESS",

  UPDATE_ORGANIZATION_REQUEST: "UPDATE_ORGANIZATION_REQUEST",
  UPDATE_ORGANIZATION_SUCCESS: "UPDATE_ORGANIZATION_SUCCESS",

  GET_ORGANIZATION_RESTAURANTS_REQUEST: "GET_ORGANIZATION_RESTAURANTS_REQUEST",
  GET_ORGANIZATION_RESTAURANTS_SUCCESS: "GET_ORGANIZATION_RESTAURANTS_SUCCESS",

  GET_FIREBIRD_DATABASE_VERSIONS_REQUEST:
    "GET_FIREBIRD_DATABASE_VERSIONS_REQUEST",
  GET_FIREBIRD_DATABASE_VERSIONS_SUCCESS:
    "GET_FIREBIRD_DATABASE_VERSIONS_SUCCESS",

  GET_FIREBIRD_DATABASE_VERSIONS_CLOSE_MODAL:
    "GET_FIREBIRD_DATABASE_VERSIONS_CLOSE_MODAL",

  GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_REQUEST:
    "GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_REQUEST",
  GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_SUCCESS:
    "GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_SUCCESS",

  GET_MENU_CONFIGURATION_REQUEST: "GET_MENU_CONFIGURATION_REQUEST",
  GET_MENU_CONFIGURATION_SUCCESS: "GET_MENU_CONFIGURATION_SUCCESS",

  CHECK_ORGANIZATION_CONNECTION_REQUEST:
    "CHECK_ORGANIZATION_CONNECTION_REQUEST",

  GET_ALL_ORGANIZATIONS_BY_URL_REQUEST: "GET_ALL_ORGANIZATIONS_BY_URL_REQUEST",
  GET_ALL_ORGANIZATIONS_BY_URL_SUCCESS: "GET_ALL_ORGANIZATIONS_BY_URL_SUCCESS",

  GET_ORGANIZATION_DETAILS_REQUEST: "GET_ORGANIZATION_DETAILS_REQUEST",
  GET_ORGANIZATION_DETAILS_SUCCESS: "GET_ORGANIZATION_DETAILS_SUCCESS",
  GET_ORGANIZATION_DETAILS_FAILURE: "GET_ORGANIZATION_DETAILS_FAILURE",

  getOrganizations: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORGANIZATIONS_REQUEST,
      });
    };
  },

  addOrganization: (organization) => {
    return (dispatch) => {
      dispatch({
        type: actions.ADD_ORGANIZATION_REQUEST,
        organization,
      });
    };
  },

  deleteOrganization: (organization) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_ORGANIZATION_REQUEST,
        organization,
      });
    };
  },

  updateOrganization: (organization) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_ORGANIZATION_REQUEST,
        organization,
      });
    };
  },

  getCities: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_CITIES_REQUEST,
      });
    };
  },

  getOrganizationRestaurants: (organization) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORGANIZATION_RESTAURANTS_REQUEST,
        organization,
      });
    };
  },

  checkFireBirdDbVersions: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FIREBIRD_DATABASE_VERSIONS_REQUEST,
      });
    };
  },

  getFirebirdDatabaseVersionsCloseModal: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FIREBIRD_DATABASE_VERSIONS_CLOSE_MODAL,
      });
    };
  },

  checkFireBirdDbVersionsByUser: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_REQUEST,
      });
    };
  },

  getMenuConfiguration: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_MENU_CONFIGURATION_REQUEST,
      });
    };
  },

  checkOrganizationConnectionRequest: (connectionString) => {
    return (dispatch) => {
      dispatch({
        type: actions.CHECK_ORGANIZATION_CONNECTION_REQUEST,
        connectionString,
      });
    };
  },

  getAllOrganizationsByUrl: (organizationIds) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ALL_ORGANIZATIONS_BY_URL_REQUEST,
        organizationIds,
      });
    };
  },

  getOrganizationDetails: (organizationId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORGANIZATION_DETAILS_REQUEST,
        organizationId,
      });
    };
  },
};
export default actions;
